function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUsp3 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 320 160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M64.501 22.369h57.036a2.938 2.938 0 0 1 2.92 2.92v84.576a2.937 2.937 0 0 1-2.92 2.92H64.501a2.935 2.935 0 0 1-2.92-2.92V25.289a2.936 2.936 0 0 1 2.92-2.92Z",
    style: {
      fill: "#f2f2f2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.209 24.493h55.62c.83 0 1.503.674 1.504 1.504v83.161a1.514 1.514 0 0 1-1.504 1.504h-55.62a1.514 1.514 0 0 1-1.505-1.504V25.997a1.506 1.506 0 0 1 1.505-1.504Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.862 55.553c0 5.346-4.945 4.538-11.042 4.538-6.098 0-11.041.808-11.041-4.537 0-5.347 2.414-14.823 11.042-14.823 8.922 0 11.04 9.476 11.04 14.823l.001-.001Z",
    style: {
      fill: "#585ddb",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.85 100.807c.246-.467.374-.986.374-1.513 0-1.412-.92-2.669-2.266-3.097l-12.649-26.759-5.785 4.057 14.253 25.028a3.277 3.277 0 0 0-.095.783 3.283 3.283 0 0 0 3.267 3.267 3.27 3.27 0 0 0 2.902-1.766h-.001Z",
    style: {
      fill: "#a0616a",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.843 71.788-.723-1.131-.369-.581-2.841-4.453a4.051 4.051 0 0 0-3.698-2.404c-2.219 0-4.045 1.826-4.045 4.045 0 .566.118 1.125.348 1.642l.65 2.32 1.327 4.743c.081.292.253.551.49.738.418.341.993.422 1.489.209l.021-.008 3.437-1.538.006-.003 2.622-1.174.654-.29c.187-.083.354-.206.49-.36.143-.158.249-.348.308-.554a1.438 1.438 0 0 0-.166-1.201Z",
    style: {
      fill: "#ccc",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.714 109.728a1.46 1.46 0 0 0-2.619.254l-.173.475h3.23l-.438-.729Z",
    style: {
      fill: "#2f2e41",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.751,
    cy: 52.355,
    r: 7.43,
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.773 74.33c-.017-.267-.042-.53-.072-.787a16.602 16.602 0 0 0-.581-2.886 16.13 16.13 0 0 0-4.656-7.39 4.409 4.409 0 0 0-2.943-1.125H87.054c-2.42 0-4.412 1.992-4.412 4.412 0 .251.022.501.064.748-.002.004-.002.004 0 .007.075.422.21.832.403 1.216l.424.843 2.837 5.675 3.529 7.061.207.411 13.156 3.618.054-.124c.049-.109.1-.221.145-.33.073-.163.142-.327.212-.486a25.79 25.79 0 0 0 2.106-8.413v-.004c.049-.815.047-1.631-.007-2.446h.001Z",
    style: {
      fill: "#3f3d56",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.674 85.193a1.396 1.396 0 0 0-.209-.43 5.651 5.651 0 0 0-1.201-1.186l-.002-.003c-1.595-1.21-4.759-2.619-10.872-2.656h-.009c-.573 0-1.092.336-1.329.856l-.151.33-.974 2.142c-.083.183-.214.34-.378.456-1.546 1.095-9.033 7.236-4.637 20.718.542 1.67 1.055 3.349 1.537 5.037h13.177l-.282-2.117a1.115 1.115 0 0 1 .021-.415l5.303-21.883.024-.093c.062-.25.055-.51-.018-.756Z",
    style: {
      fill: "#2f2e41",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.809 60.696h5.748c.5 0 .908.407.908.908v1.511a.305.305 0 0 1 .302.304v.604a.304.304 0 0 1-.302.303v.605c.166 0 .301.136.302.303v.604a.306.306 0 0 1-.302.303v8.168a.909.909 0 0 1-.909.907h-5.747a.911.911 0 0 1-.907-.907V61.604c0-.5.406-.908.907-.908Z",
    style: {
      fill: "#3f3d56",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.506 74.309V61.603c0-.5.407-.907.908-.907h-.605a.908.908 0 0 0-.907.908v12.705c0 .501.406.907.907.907h.605a.912.912 0 0 1-.908-.907v-.001.001Z",
    style: {
      fill: "#ff4d3c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110.532,
    cy: 64.931,
    r: 1.21,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.997 69.17a3.184 3.184 0 0 0-.262.428L93.84 71.387l-2.19-2.913-4.828 2.732 3.376 5.533a2.427 2.427 0 0 0 2.698 1.075l16.476-4.458c.589.559 1.371.87 2.183.87a3.19 3.19 0 0 0 3.175-3.175 3.19 3.19 0 0 0-3.175-3.176 3.18 3.18 0 0 0-2.559 1.295h.001Z",
    style: {
      fill: "#a0616a",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.716 69.523-4.176-5.409a3.783 3.783 0 0 0-3.301-1.94 3.798 3.798 0 0 0-3.78 3.78c0 .461.084.918.248 1.348-.002.004-.002.004 0 .007.063.165.137.325.225.477l.602 1.582 1.83 4.825c.166.438.547.761 1.007.85.317.065.647.013.929-.145l1.325-.741 4.676-2.613a1.365 1.365 0 0 0 .414-2.021h.001Z",
    style: {
      fill: "#3f3d56",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.198 53.738h2.939l1.297-4.467.259 4.467h1.405l.755-2.606.152 2.606h10.437c0-5.346-3.52-9.679-7.865-9.679h-1.513c-4.343 0-7.865 4.333-7.865 9.679h-.001Z",
    style: {
      fill: "#585ddb",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.374 48.059h-61.585a2.938 2.938 0 0 1-2.92-2.92V13.816a2.938 2.938 0 0 1 2.919-2.921h61.586a2.937 2.937 0 0 1 2.92 2.921v31.323a2.936 2.936 0 0 1-2.92 2.92Z",
    style: {
      fill: "#ccc",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.666 45.936h-60.169a1.514 1.514 0 0 1-1.505-1.505V14.523c0-.83.674-1.503 1.505-1.504h60.169c.83.001 1.504.674 1.504 1.504v29.908c0 .825-.679 1.504-1.504 1.505Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.481 53.817a1.16 1.16 0 0 1-.435-.087 1.103 1.103 0 0 1-.691-1.034v-5.757l8.676-.219-6.767 6.767a1.108 1.108 0 0 1-.783.33Zm49.86-25.681h-30.439a1.422 1.422 0 0 1-1.416-1.416c0-.777.639-1.416 1.416-1.416h30.439c.777 0 1.416.639 1.416 1.416 0 .777-.639 1.416-1.416 1.416Zm-9.911-6.017H131.9a1.422 1.422 0 0 1-1.415-1.416c0-.776.639-1.415 1.415-1.415h20.53c.776 0 1.415.639 1.415 1.415 0 .777-.639 1.416-1.415 1.416Z",
    style: {
      fill: "#ccc",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.301,
    cy: 23.712,
    r: 4.425,
    style: {
      fill: "#ff4d3c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.96,
    cy: 38.252,
    r: 1.416,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.915,
    cy: 38.252,
    r: 1.416,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.87,
    cy: 38.252,
    r: 1.416,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.463 69.862h57.036a2.936 2.936 0 0 1 2.92 2.92v84.576a2.936 2.936 0 0 1-2.919 2.92h-57.036a2.939 2.939 0 0 1-2.921-2.92V72.782a2.938 2.938 0 0 1 2.92-2.92Z",
    style: {
      fill: "#f2f2f2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.171 71.986h55.621c.83.001 1.503.673 1.504 1.504v83.16a1.513 1.513 0 0 1-1.505 1.504h-55.62a1.513 1.513 0 0 1-1.504-1.504V73.49c0-.83.674-1.503 1.504-1.504Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.858 112.682h-61.584a2.937 2.937 0 0 1-2.921-2.919V78.439a2.936 2.936 0 0 1 2.92-2.92h61.585a2.937 2.937 0 0 1 2.92 2.92v31.324a2.937 2.937 0 0 1-2.92 2.919Z",
    style: {
      fill: "#ccc",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.151 110.559h-60.17a1.513 1.513 0 0 1-1.504-1.505V79.146a1.507 1.507 0 0 1 1.504-1.504h60.17c.83.001 1.503.675 1.504 1.504v29.908a1.513 1.513 0 0 1-1.504 1.505Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.667 118.11-6.768-6.767 8.676.219v5.757c.005.453-.27.865-.69 1.034a1.105 1.105 0 0 1-1.219-.242l.001-.001Zm-3.842-25.351h-30.439a1.422 1.422 0 0 1-1.415-1.416c0-.776.638-1.415 1.415-1.415h30.439c.776 0 1.415.639 1.415 1.415 0 .777-.639 1.416-1.415 1.416Zm-9.91-6.017h-20.529a1.422 1.422 0 0 1-1.416-1.415c0-.777.639-1.416 1.416-1.416h20.529c.777 0 1.416.639 1.416 1.416 0 .776-.639 1.415-1.416 1.415Z",
    style: {
      fill: "#ccc",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.785,
    cy: 88.335,
    r: 4.425,
    style: {
      fill: "#ff4d3c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.444,
    cy: 102.875,
    r: 1.416,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.4,
    cy: 102.875,
    r: 1.416,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.355,
    cy: 102.875,
    r: 1.416,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.535 131.642a3.045 3.045 0 0 1 4.635-.528l9.606-4.958-.597 5.585-9.03 3.853a3.062 3.062 0 0 1-2.077.813 3.072 3.072 0 0 1-3.057-3.058c0-.608.181-1.203.521-1.707h-.001Z",
    style: {
      fill: "#ffb8b8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.444 106.809a4.39 4.39 0 0 0-6.171.766l-8.433 15.642-7.784 5.881c-.457.344-.65.941-.481 1.488l.766 2.468c.082.265.242.5.459.672.096.071.2.131.309.178.343.148.732.146 1.074-.002l9.123-3.958.1-.045a14.015 14.015 0 0 0 6.998-6.821l4.797-10.125c1.47-1.895 1.13-4.662-.757-6.144Z",
    style: {
      fill: "#3f3d56",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.411,
    cy: 93.616,
    r: 7.43,
    style: {
      fill: "#ffb8b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.44 143.3-.076-.578-.351-2.634-.384-2.877-1.364.232-.527.088-.533.091-.174.03-13.534 2.299-1.686-1.013-.035-.021.015.154.317 3.294 1.516 15.737h18.791L237.44 143.3Z",
    style: {
      fill: "#2f2e41",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.643 113.071a10.485 10.485 0 0 0-3.554-6.969 9.898 9.898 0 0 0-7.155-2.469c-2.495.166-4.413 1.192-5.738 3.058a10.468 10.468 0 0 0-1.488 3.28c-1.507 5.42-3.095 13.361-4.302 19.928a604.382 604.382 0 0 0-1.616 9.173c-.139.831-.244 1.481-.314 1.914a1.36 1.36 0 0 0 .632 1.38l.012.009a10.008 10.008 0 0 0 5.05 1.418c2.153 0 4.736-.75 7.456-3.173.38-.345.957-.369 1.364-.057l.297.23 2.928 2.277c.357.28.831.363 1.261.221.428-.14.76-.483.883-.917.164-.568.345-1.225.545-1.957l.254-.958a150.17 150.17 0 0 0 1.228-5.034c1.459-6.492 2.844-14.832 2.257-21.354Z",
    style: {
      fill: "#3f3d56",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.408 144.076a3.056 3.056 0 0 1 3.321-3.276l4.498-9.827 2.978 4.762-4.729 8.604a3.067 3.067 0 0 1-3.019 2.571 3.07 3.07 0 0 1-3.049-2.834Z",
    style: {
      fill: "#ffb8b8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.477 121.375-2.475-10.929c-.014-2.397-1.988-4.363-4.385-4.368-2.407.006-4.384 1.988-4.384 4.394v.019l3.02 17.511-.009.037-1.601 6.041-.886 3.354a.535.535 0 0 0-.018.097c-.057.282-.02.574.105.832.101.217.258.403.454.538l1.715 1.187.409.283c.227.159.498.243.774.242.107 0 .214-.012.318-.035l.033-.009c.362-.096.669-.337.848-.666l4.736-8.745a14.048 14.048 0 0 0 1.346-9.783Z",
    style: {
      fill: "#3f3d56",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.836 117.875 2.722 11.495-3.932 9.68 2.722-9.377-1.512-11.798Z",
    style: {
      fillOpacity: 0.2,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.424 98.08a4.984 4.984 0 0 0 1.684-1.008c.217-.194.449-.374.664-.567 1.906-1.703 2.479-4.633 1.629-7.044-.85-2.411-2.965-4.263-5.381-5.098-2.415-.835-5.093-.721-7.546-.003-2.642.775-5.288 2.518-5.916 5.198-.166.714-.173 1.506.313 2.108.146.181.337.321.555.406.856.328 1.333-.341 1.972-.626.878-.391 1.96.031 2.571.774.612.742.838 1.727.931 2.684.02.59.112 1.175.277 1.742a1.738 1.738 0 0 0 1.212 1.177c.69.127 1.352-.348 1.787-.898.433-.551.74-1.206 1.252-1.683.513-.478 1.349-.731 1.91-.312.189.159.347.35.469.564.861 1.322.757 1.265 1.617 2.586Z",
    style: {
      fill: "#2f2e41",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.844 125.28-5.242 2.359a.907.907 0 0 0-.456 1.199l.621 1.381c-.151.068-.219.248-.151.399l.248.552c.068.151.248.22.4.152l.248.551a.304.304 0 0 0-.151.4l.248.552a.305.305 0 0 0 .4.152l3.351 7.449a.907.907 0 0 0 1.199.454l5.242-2.358a.906.906 0 0 0 .455-1.199l-5.213-11.587a.912.912 0 0 0-1.199-.456Z",
    style: {
      fill: "#3f3d56",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.285 136.639-.739-1.643-1.935-4.301-1.7-3.778a.875.875 0 0 0-1.15-.439l-2.886 1.297-1.321.597a.876.876 0 0 0-.436 1.149l1.757 3.908.675 1.497 1.942 4.32a.877.877 0 0 0 1.153.436l4.205-1.894a.875.875 0 0 0 .435-1.149Z",
    style: {
      fill: "#ff4d3c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h320v160H0z"
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUsp3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/usp3.413e4bec05786945d8f5acd91430b220.svg";